export default {
  /*
   * index() lista los puntos
   */
  index(params) {
    return Vue.http.get('topology/points', params).then(response => response.data)
  }
}
